@if (widget) {
    <mvs-widget
            [widgetData]="widget"
            (onObjectSelect)="onItemSelect($event)"
    ></mvs-widget>
}
